import { logout } from '@/redux/slices/user.slice';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ReferralsState { 
  data: any[];
}

const initialState: ReferralsState = {
    data: []
};

const referralsSlice = createSlice({
  name: 'referrals',
  initialState,
  reducers: {
    setReferrals: (state, action: PayloadAction<ReferralsState>) => {
      state.data = action.payload.data;
    },
    clearReferrals: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => [
    builder.addCase(logout, (state) => {
      return initialState;
    })
  ]
});

export const { setReferrals, clearReferrals } = referralsSlice.actions;
export default referralsSlice.reducer;
